import { render, staticRenderFns } from "./testPlanComments.vue?vue&type=template&id=cc635d70"
import script from "./testPlanComments.vue?vue&type=script&lang=js"
export * from "./testPlanComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports